import styled from 'styled-components'

export const NewSiteTabWrapper = styled.div`
  display: flex;
  height: 72px;
`

export const NewSiteTabItem = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: 500;
  padding: 0 16px;
  color: ${(p) => {
    return p.isActive ? '#0aa1f4' : 'rgba(32, 32, 32, 1)'
  }};
  cursor: pointer;
  border-bottom: ${(p) => {
    return p.isActive ? '2px solid rgba(10, 161, 244, 1)' : '2px solid rgba(255, 255, 255, 1)'
  }};

  :hover {
    color: #0aa1f4;
  }
`
